import { Injectable } from '@angular/core';
import { IEscalateCase } from 'app/shared/models/escalate-case.model';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  ticketEscalationData!: IEscalateCase | null;
  ticketEscalationId!: number;

  constructor() { }
}
